module.exports = __webpack_public_path__ + "img/img0204.7b3df7c0.png";